// extracted by mini-css-extract-plugin
export var authorImage = "s56uw";
export var authorLabelWrittenBy = "_3EJgZ";
export var authorRoot = "vhNlt";
export var colContent = "NEEuK";
export var imageWrapperCenterImg = "_8qK0N";
export var imageWrapperHalfWidth = "XvCD+";
export var root = "ujZH4";
export var subtitle = "MFtKF";
export var title = "JFnRk";